<template>
<div class="container">
<div class="row">
	<h3>{{info.title}}</h3>
</div>

<div class="row" style="color:  #708090;" v-if="info">
    <div class="col-1"></div>
	<div class="col-3">{{info.author}}</div>
	<div class="col-3 center">阅读 (<span style="color:#00BFFF">{{info.visit}}</span>)</div>
	<div class="col-3">{{info.time}}</div>
</div>

<div class="row acticle" v-html="pic(info.content)" v-if="info">
	
</div>

<div class="row center" style="padding-top:40%;" v-if="!info">正在加载中...</div>

<nomore v-if="info"></nomore>

</div>	
</template>

<style scoped>
.acticle{max-width:100% !important;min-height:75vh;padding-bottom: 1rem;width:98%;margin:1%;overflow: hidden;line-height:1.5rem;}
.acticle p{margin-bottom:1rem !important;}
h3,.center{text-align: center;}
.pad{padding:1rem 0.5rem;}
.middle-line{border-bottom: 1px  solid #ddd;margin-top: .5rem;}
</style>

<script>
import nomore from "../../lib/nomore.vue";


export default{
		data(){
			return {
				info:"",
				content:"",
                mydata:mydata,
                pic:fun.contentPic,//是一个函数
			}
        },
        components:{nomore},
		created:function(){
          this.mydata.back=true;
          this.init();
          //this.mydata.nav="文章详情";
		},
        beforeDestroy:function(){
          this.mydata.back=false;
        },
		methods:{
         init:function(){
         	var _this=this;
         	var data={
         		nid:this.$route.params.nid,
         		aid:this.$route.params.b,
         	};
            var key=fun.url();
            this.get(data);
         },
         get:function(data){
             var _this=this;
             var load=data.new?false:true;
             fun.post(api+"acticle",data,function(d){
                console.log(d);
                if(d.status==1){
                    _this.info=d.info;
                }else{
                    _this.$toast(d.info);
                }
            },data.new)
         }
		}

}	


</script>


// WEBPACK FOOTER //
// src/components/thm/article.vue